<script>
  import {NODE_ENV} from 'vue-src/utils/constants'
  import template from 'lodash-es/template'
  import decodeHtml from '^/utils/decodeHtml'

  export default {
    name: "base-snippet",
    functional: true,
    props: {
      name: {
        type: String,
        required: true,
      },
      context: {
        type: Object,
        default: null,
      }
    },
    render(h, {props, children}) {
      let name = props.name
      let snippet = decodeHtml(window.ixsnippet(name, ''))
      let default_text = ''
      if(children){
        children.forEach(e=>default_text+=e.text+' ')
      }
      let result = !!snippet ? snippet : default_text
      const attrs = {
        'data-snippet': name,
      }
      if(props.context){
        attrs['data-context'] = JSON.stringify(props.context)
        const output_function = template(result)
        result = output_function(props.context)
      }

      if (NODE_ENV === 'production') {
        return result
      }

      return h(
          'span',
          {
            attrs:attrs,
          },
          [result]
      )
    },
  }
</script>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-snippet.vue